import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M11.25 7.5a3 3 0 00-.6 5.94.75.75 0 01-.3 1.47 4.501 4.501 0 115.31-5.31.75.75 0 01-1.47.3 3.001 3.001 0 00-2.94-2.4z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M2.25 3.75a1.5 1.5 0 011.5-1.5h15a1.5 1.5 0 011.5 1.5v6a.75.75 0 01-1.5 0v-6h-15v15h6.75a.75.75 0 010 1.5H3.75a1.5 1.5 0 01-1.5-1.5v-15z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M11.245 14.208a.75.75 0 01-.662.829 6 6 0 00-5.183 4.63.75.75 0 01-1.463-.334 7.5 7.5 0 016.48-5.787.75.75 0 01.828.662zM14.25 13.5V21h6v-5.314L18.064 13.5H14.25zm-1.17-1.17c.21-.212.497-.33.795-.33h4.5a.75.75 0 01.53.22l2.625 2.625c.141.14.22.331.22.53v6a1.125 1.125 0 01-1.125 1.125h-6.75a1.125 1.125 0 01-1.125-1.125v-8.25c0-.298.118-.585.33-.796z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M18.375 12a.75.75 0 01.75.75v1.875H21a.75.75 0 010 1.5h-2.625a.75.75 0 01-.75-.75V12.75a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
